import type {
  PatchDocumentArchiveRequestType,
  PatchDocumentArchiveResponseType,
} from 'entities/document/api/types';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

export const patchDocumentArchive = async ({
  documentId,
}: PatchDocumentArchiveRequestType) => {
  const url = `/api/v2/documents/${documentId}/archive`;
  const response =
    await apiAuthClient.patch<PatchDocumentArchiveResponseType>(url);

  return response.data;
};
